import { connect } from "react-redux";
import InvoiceList from "./invoiceList";
import { bindActionCreators } from "redux";
import { getPerformaInvoice } from "services/redux/sales/businessListing/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.approvedSalesListReducer.postSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getPerformaInvoice,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList);
